import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useEffect, useRef} from 'react'

export function recoverIssueViewerContainerLayout(container: HTMLDivElement) {
  const header = container.querySelector('[data-testid="issue-header"]')
  if (!header || header.getBoundingClientRect().height !== 0) return

  const originalDisplay = container.style.display
  container.style.display = 'none'
  void container.offsetHeight
  container.style.display = originalDisplay
}

export function useIssueViewerContainerQueryFix(owner: string, repo: string, number: number) {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!isFeatureEnabled('issues_react_chrome_container_query_fix')) return

    const container = containerRef.current
    if (!container) return

    // Chrome can leave an inline-size container at zero dimensions after SPA navigation.
    const timeoutId = setTimeout(() => recoverIssueViewerContainerLayout(container), 50)

    return () => clearTimeout(timeoutId)
  }, [owner, repo, number])

  return containerRef
}
